export default map => ({
  lngMin: map.getBounds().getSouthWest().lng(),
  latMin: map.getBounds().getSouthWest().lat(),
  lngMax: map.getBounds().getNorthEast().lng(),
  latMax: map.getBounds().getNorthEast().lat()
});
